import createAxiosInstance from './createAxiosInstance'

const mvcAjax = process.env.NODE_ENV === 'development' ? '/house/' : process.env.VUE_APP_WS_URL
const ajaxInstance = createAxiosInstance(mvcAjax)

export const apiAjax = {
  checkReservation: () => ajaxInstance.post('/checkReservation'), // 取得右下角 Alert - 公設預約
  checkMessageFeedback: () => ajaxInstance.post('/checkMessageFeedback') // 取得右下角 Alert - 意見反映
}
